// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2gLuv","footer":"ModalError_footer__2e9Oe"};